<template>
  <validation-observer ref="formObserver" v-slot="{ passes }" tag="div">
    <form @submit.prevent="passes(verifySectionSelected)">
      <h2 class="bg-green-500 py-3 px-5 text-white mb-8">
        Step 4: Company Information
      </h2>
      <d-field label="AWI Standards">
        <div>
          <div>
            <d-checkbox v-model="awiStandards" native-value="I currently own a copy of the AWI Quality Standards Illustrated, 8th Edition, Version 2">
              I currently own a copy of the AWI Quality Standards Illustrated, 8th Edition, Version 2
            </d-checkbox>
          </div>
          <div>
            <d-checkbox v-model="awiStandards" native-value="I currently own a copy of the Architectural Woodwork Standards, Edition 1">
              I currently own a copy of the Architectural Woodwork Standards, Edition 1
            </d-checkbox>
          </div>
          <div>
            <d-checkbox v-model="awiStandards" native-value="My company is currently an active AWI Member">
              My company is currently an active AWI Member
            </d-checkbox>
          </div>
          <div>
            <d-checkbox v-model="awiStandards" native-value="Please send me AWI Membership information">
              Please send me AWI Membership information
            </d-checkbox>
          </div>
        </div>
      </d-field>
      <d-field label="How did you hear about the QCP?">
        <d-select v-model="hearAboutQpc" required expanded>
          <option value="Article">
            Article
          </option>
          <option value="Ad">
            Ad
          </option>
          <option value="Seminar">
            Seminar
          </option>
          <option value="Member">
            Member
          </option>
          <option value="Architect">
            Architect
          </option>
          <option value="Other">
            Other (please specify)
          </option>
        </d-select>
      </d-field>
      <div v-if="hearAboutQpc == 'Other'">
        <d-field label="&quot;If &quot; Other&quot;, please specify&quot;">
          <d-input v-model="hearAboutQpcOther" aria-label="other way you heard about qcp" />
        </d-field>
      </div>


      <div class="flex flex-wrap -mx-5 mb-4 md:mb-0">
        <d-field label="Licensing Type" class="w-full md:w-1/2 px-5">
          <d-select v-model="licensingType" required expanded>
            <option value="Fabrication">
              Fabrication
            </option>
            <option value="Finishing">
              Finishing
            </option>
            <option value="Installation">
              Installation
            </option>
          </d-select>
        </d-field>
        <d-field label="Quality Grade" class="w-full md:w-1/2 px-5">
          <d-select v-model="quailityGrade" required expanded>
            <option value="Premium Grade and below">
              Premium Grade and below
            </option>
            <option value="Custom Grade only">
              Custom Grade only
            </option>
          </d-select>
        </d-field>
      </div>

      <d-field label="Licensing Sections">
        <div>
          <div class="mb-3">
            <a href="javascript:;" @click="triggerAllSections(true)">Select All</a> | <a href="javascript:;" @click="triggerAllSections(false)">Select None</a>
          </div>
          <div v-for="section in availableSections" :key="section.code" class="mb-1">
            <d-checkbox v-model="licensingSections" :native-value="section.code">
              {{ section.name }}
            </d-checkbox>
          </div>
        </div>
      </d-field>

      <div class="flex flex-wrap justify-center md:justify-end pt-5">
        <d-btn class="mx-5" @click="goToPrevPage">
          Prev <span class="hidden sm:block sm:ml-1">Step</span>
        </d-btn>
        <d-btn type="submit" class="mx-5 md:mx-0">
          Next <span class="hidden sm:block sm:ml-1">Step</span>
        </d-btn>
      </div>
    </form>
  </validation-observer>
</template>

<script>
  import axios from 'axios';
  import { createNamespacedHelpers } from 'vuex';
  import { mapFields } from '../../../../Resources/scripts/utilities/field.utilities';
  import { APPLY_FOR_LICENSING_FORM } from '../../../../Resources/scripts/store/mutation-types';

  const { mapActions } = createNamespacedHelpers('applyForLicensing');

  export default {
    parent: true,

    data() {
      return {
        availableSections: [],
      };
    },

    computed: {
      ...mapFields({
        fields: ['awiStandards', 'hearAboutQpc', 'hearAboutQpcOther', 'licensingType', 'quailityGrade', 'licensingSections'],
        module: 'applyForLicensing',
        base: 'formFields',
        mutation: APPLY_FOR_LICENSING_FORM.FORM_FIELDS,
      }),
    },

    watch: {
      quailityGrade() {
        this.getTestSections();
      },

      licensingType() {
        this.getTestSections();
      },
    },

    mounted() {
      this.getTestSections();
    },

    methods: {
      ...mapActions([
        'goToPrevPage',
        'goToNextPage',
      ]),

      verifySectionSelected() {
        if (this.licensingSections.length === 0) {
          return this.$toast.error('You must select a licensing section to continue.');
        }
        return this.goToNextPage();
      },

      async getTestSections() {
        let qualityGrade = '';
        if (this.quailityGrade.toLowerCase() === 'Custom Grade only'.toLowerCase()) {
          qualityGrade = 'C';
        } else {
          qualityGrade = 'P';
        }
        const { data } = await axios.get(`/api/tests/sections/codes-names?qualityGrade=${qualityGrade}&licenseType=${this.licensingType}`);
        this.availableSections = data;
        this.triggerAllSections(false);
      },

      triggerAllSections(selectAll) {
        if (selectAll) {
          this.licensingSections = JSON.parse(JSON.stringify(this.availableSections.map(x => x.code)));
        } else {
          this.licensingSections = [];
        }
      },
    },
  };
</script>